import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { ProfileService } from "../../profile/profile.service";
import { isOpsAdminUser } from "../helpers/ops-ui-profile.helper";

export const opsAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const profileService = inject(ProfileService);

  // loadOpsInitialDataGuard loads profile first; getUserProfile dedupes in-flight GET /user/me.
  const profile$ = profileService.getUserProfile();

  return profile$.pipe(
    map((profile) =>
      isOpsAdminUser(profile) ? true : router.createUrlTree(["/dashboard"]),
    ),
    catchError(() => of(router.createUrlTree(["/dashboard"]))),
  );
};
